import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanyLegalStatusInput = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      name="legalStatusCustom"
      render={({ field }) => (
        <Input
          {...field}
          size="sm"
          placeholder={t('settings.organization.organization_info.basic_info.legal_status_custom.placeholder')}
        />
      )}
    />
  )
}
